import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ChainedBackend from "i18next-chained-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import HttpBackend from "i18next-http-backend";
import { locizePlugin } from "locize";
import { initReactI18next } from "react-i18next";

export interface CachedLanguages {
  languages: Language[];
  expires: Date;
}
export interface Language {
  id: string;
  region: string;
  nativeName: string;
  flagIconKey?: string;
  momentKey: string;
}

let locizeVersion = "latest";
let expirationTime = 10 * 60000; // 10min

if (process.env.REACT_APP_ENVIRONMENT === "production") {
  locizeVersion = "production";
  expirationTime = 120 * 60000; // 2h
}

if (process.env.REACT_APP_ENVIRONMENT === "stage") {
  locizeVersion = "staging";
  expirationTime = 60 * 60000; // 1h
}

i18n
  .use(ChainedBackend)
  .use(locizePlugin)
  .use(LanguageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(
    {
      load: "currentOnly",
      defaultNS: "Common",
      ns: [
        "CommonEnum",
        "Common",
        "Objects",
        "Organizations",
        "Transmitters",
        "Locations",
        "Messages",
        "Filters",
        "AlarmHistory",
        "Errors",
        "Home",
        "Menu",
        "Table",
        "Language",
        "LogEvent",
        "Contacts",
        "Administrator",
        "Settings",
        "Cameras",
        "Reports",
        "Reseller",
        "AlarmReceptions",
        "Roles",
        "Languages",
        "Permissions",
      ],
      debug: false, // !isProduction,
      fallbackLng: (code: string) => {
        // load all possible fallback languages in decending order i.e.
        // nb-NO-x-care-doro falls back on nb-NO-x-care
        // nb-NO-x-care falls back on nb-NO-x
        // nb-NO-x falls back on nb-NO
        const fallbacks = [];
        const splitString = code.split("-");

        let i = splitString.length;
        while (i > 1) {
          if (splitString[i - 1] === "x") {
            i -= 1;
            continue;
          }

          fallbacks.push(splitString.slice(0, i).join("-"));
          i -= 1;
        }

        fallbacks.push("en-GB");
        return fallbacks;
      },
      saveMissing: false,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      backend: {
        backends: [LocalStorageBackend, HttpBackend, HttpBackend],
        backendOptions: [
          {
            expirationTime,
          },
          {
            loadPath: `/translations/AdminUI2/${locizeVersion}/{{lng}}/{{ns}}.json`,
          },
          {
            loadPath: `/translations/Backend/${locizeVersion}/{{lng}}/{{ns}}.json`,
          },
        ],
      },
      react: {
        useSuspense: true,
      },
      keySeparator: " ",
    },
    () => {}
  );

export default i18n;
